
import Oidc from 'oidc-client';
import config from '@/config/config.json';

const isDevelopment = process.env.NODE_ENV !== 'production';
var redirectUri = window.location.origin +
  (process.env.IS_ELECTRON && !isDevelopment
    ? '/index.html#callback'
    : '/callback');

const silentUrl = window.location.origin +
(process.env.IS_ELECTRON && !isDevelopment
  ? '/index.html#silent-renew'
  : '/silent-renew');

var userManager = new Oidc.UserManager({
    userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
    authority: config.issuer,
    client_id: config.clientId,
    scope: config.scope,
    response_type: 'code',
    redirect_uri: redirectUri,
    post_logout_redirect_uri: window.location.origin,
    silent_redirect_uri: silentUrl,
    automaticSilentRenew: true,
    monitorSession: true
});

class AuthService {
    login (returnPath) {
        userManager.signinRedirect({ state: returnPath })
        .catch(error => console.log(error))
    }

    logout () {
      userManager.signoutRedirect()
        .catch(error => console.log(error))
    }

    handleLoginRedirect () {
      return userManager.signinRedirectCallback()
    }

    handleLogoutRedirect () {
      return userManager.signoutRedirectCallback()
    }

    handleLogoutRenew() {
      return userManager.signinSilentCallback();
    }

    isUserLoggedIn () {
      return new Promise((resolve, reject) => {
        userManager.getUser()
          .then(user => {
            if (user === null || user.expired) {
                resolve(false);
            } else {
                resolve(true);
            }
          })
          .catch(error => reject(error))
      })
    }

    getAccessToken () {
      return new Promise((resolve, reject) => {
        userManager.getUser()
          .then(user => { resolve(user.id_token) })
          .catch(error => reject(error))
      })
    }

    refreshToken() {
      return new Promise((resolve, reject) => {
        userManager.signinSilent()
          .then(user => resolve(user.id_token))
          .catch(error => reject(error) )
      });
    }

    async hasPermission(role) {
      const user = await userManager.getUser();
      return !!user?.profile?.roles && user.profile.roles.some(x => x === config.roles[role]);
    }
  };

  export const authService = new AuthService()

  export default {
    install: function (Vue) {
      Vue.prototype.$auth = authService
    }
  }
